/* eslint-disable @typescript-eslint/ban-ts-comment */
import { store } from '@/store';
import { BaseCompoundFormFieldBuilder } from '.';
import { FormFieldType, QuestionWithDetailsFormField } from '../typings';
import { setConditionalParentFields } from '../store';

export class QuestionWithDetailsFormFieldBuilder extends BaseCompoundFormFieldBuilder<QuestionWithDetailsFormField> {
  protected _type = FormFieldType.QuestionWithDetails;
  protected _typeValue = FormFieldType.QuestionWithDetails;
  // @ts-ignore
  private _question: QuestionWithDetailsFormField['question'] =
    'Question not provided';
  // @ts-ignore
  private _answer: QuestionWithDetailsFormField['answer'];
  // @ts-ignore
  private _trueOptionText: QuestionWithDetailsFormField['trueOptionText'] =
    'TrueOptionText not provided';
  // @ts-ignore
  private _falseOptionText: QuestionWithDetailsFormField['falseOptionText'] =
    'FalseOptionText not provided';
  // @ts-ignore
  private _trueDetails: QuestionWithDetailsFormField['trueDetails'];
  // @ts-ignore
  private _falseDetails: QuestionWithDetailsFormField['falseDetails'];
  // @ts-ignore
  private _matchingAnswer: QuestionWithDetailsFormField['matchingAnswer'];
  // @ts-ignore
  private _matchingDetails: QuestionWithDetailsFormField['matchingDetails'];
  // @ts-ignore
  private _isEditable: QuestionWithDetailsFormField['isEditable'] = true;
  // @ts-ignore
  private _isRequired: QuestionWithDetailsFormField['isRequired'] = false;

  constructor() {
    super();
  }

  public question(value: QuestionWithDetailsFormField['question']): this {
    this._question = value;
    return this;
  }

  public answer(value: QuestionWithDetailsFormField['answer']): this {
    this._answer = value;
    return this;
  }

  public trueOptionText(
    value: QuestionWithDetailsFormField['trueOptionText'],
  ): this {
    this._trueOptionText = value;
    return this;
  }

  public falseOptionText(
    value: QuestionWithDetailsFormField['falseOptionText'],
  ): this {
    this._falseOptionText = value;
    return this;
  }

  public trueDetails(value: QuestionWithDetailsFormField['trueDetails']): this {
    this._trueDetails = value;

    this._syncConditionalParentFields();

    return this;
  }

  public falseDetails(
    value: QuestionWithDetailsFormField['falseDetails'],
  ): this {
    this._falseDetails = value;

    this._syncConditionalParentFields();

    return this;
  }

  public matchingAnswer(
    value: QuestionWithDetailsFormField['matchingAnswer'],
  ): this {
    this._matchingAnswer = value;
    return this;
  }

  public matchingDetails(
    value: QuestionWithDetailsFormField['matchingDetails'],
  ): this {
    this._matchingDetails = value;

    this._syncConditionalParentFields();

    return this;
  }

  public isEditable(value: QuestionWithDetailsFormField['isEditable']): this {
    this._isEditable = value;
    return this;
  }

  public isRequired(value: QuestionWithDetailsFormField['isRequired']): this {
    this._isRequired = value;
    return this;
  }

  private _syncConditionalParentFields(): void {
    const childrenIds: string[] = [];

    if (this._trueDetails) {
      childrenIds.push(this._trueDetails.fieldId);
    }
    if (this._falseDetails) {
      childrenIds.push(this._falseDetails.fieldId);
    }
    if (this._matchingDetails) {
      childrenIds.push(this._matchingDetails.fieldId);
    }

    store.dispatch(
      setConditionalParentFields({
        [this._fieldId]: childrenIds,
      }),
    );
  }
}
